import React from 'react';
var Col = function (props) {
    var col = props.col, sm = props.sm, md = props.md, lg = props.lg, xl = props.xl, offset = props.offset, offsetSm = props.offsetSm, offsetMd = props.offsetMd, offsetLg = props.offsetLg, offsetXl = props.offsetXl, align = props.align, className = props.className, children = props.children;
    var classes = [col ? "col-" + col : 'col'];
    if (sm !== undefined)
        classes.push("col-sm-" + sm);
    if (md !== undefined)
        classes.push("col-md-" + md);
    if (lg !== undefined)
        classes.push("col-lg-" + lg);
    if (xl !== undefined)
        classes.push("col-xl-" + xl);
    if (offset !== undefined)
        classes.push("offset-" + offset);
    if (offsetSm !== undefined)
        classes.push("offset-sm-" + offsetSm);
    if (offsetMd !== undefined)
        classes.push("offset-md-" + offsetMd);
    if (offsetLg !== undefined)
        classes.push("offset-lg-" + offsetLg);
    if (offsetXl !== undefined)
        classes.push("offset-xl-" + offsetXl);
    if (align !== undefined)
        classes.push("align-self-" + align);
    if (className !== undefined)
        classes.push(className);
    return React.createElement("div", { className: classes.join(' ') }, children);
};
export default Col;
